/* === Sroll to anchor ===*/

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);

    const targetElement = document.getElementById(targetId);
    const targetOffsetTop = targetElement.offsetTop;

    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();
    const startScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollEnd = targetOffsetTop - 80; // Adjust offset as needed

    function animateScroll() {
      const elapsed = performance.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easeOutQuart(progress);
      const scrollTop = startScrollTop + (scrollEnd - startScrollTop) * ease;

      window.scrollTo(0, scrollTop);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }

    animateScroll();
  });
});

// Easing function (optional) - can be customized
function easeOutQuart(t) {
  return 1 - (--t) * t * t * t;
}